/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { ActivatedRouteSnapshot } from '@angular/router';

import { ConfigService } from './../../core/services/config.service';
import { Injectable } from '@angular/core';
import { LmsEventDetails } from './../../core/model/lms-event-details.model';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { Tab } from '../../core/model/tab.model';
import { TabService } from './../../core/services/tab.service';
import { TerminalHandlingService } from './services/terminal-handling.service';

/**
 * @export
 * @class TerminalHandlingResolver
 * @implements {Resolve<Tab>}
 */
@Injectable()
export class TerminalHandlingResolver  {

    /**
     * Creates an instance of TerminalHandlingResolver.
     * @param {TabService} tabService
     * @param {TerminalHandlingService} terminalHandlingService
     * @param {ConfigService} configService
     * @param {LmsModuleService} lmsModuleService
     * @param {LmsLoaderService} lmsLoaderService
     *
     * @memberOf TerminalHandlingResolver
     */
    constructor(
        private tabService: TabService,
        private terminalHandlingService: TerminalHandlingService,
        private configService: ConfigService,
        private lmsModuleService: LmsModuleService,
        private lmsLoaderService: LmsLoaderService
    ) { }

    resolve(route: ActivatedRouteSnapshot) {
        let tab = this.tabService.getTabById(Math.abs(route.params['tabid']))[0];
        let tabType = this.configService.getConfigData().tab.event.update;
        if (!tab) {
            tabType = this.configService.getConfigData().tab.event.add;
            tab = { tabSearchParameter: { searchText: (route.queryParams['search'] ? route.queryParams['search'] : '') }, description: '' };
        }
        if (!(tab.subTypeDetail && tab.subTypeDetail.handling && tab.subTypeDetail.handling.status)) {
            if (!tab.subTypeDetail) {
                tab.subTypeDetail = {};
            }
            tab.subTypeDetail['handling'] = {
                message: '',
                status: 'blank'
            };
        }

        if (tab.tabSearchParameter && tab.tabSearchParameter.searchText) {
            if ((tabType === this.configService.getConfigData().tab.event.add) || (tab.subTypeDetail.handling.status === 'blank')) {
                tab.subTypeDetail.handling.status = 'refresh';
            }
        }

        tab.type = 'Terminal';
        tab.subType = 'Handling';

        if ('error' === tab.subTypeDetail.handling.status) {
            tab.description = tab.description;
        } else {
            tab.description = tab.tabSearchParameter.searchText ? `${tab.tabSearchParameter.searchText} - ${tab.subType}` : tab.description;
        }

        if (tabType === this.configService.getConfigData().tab.event.add) {
            tab.id = route.params['tabid'];
            if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
                this.lmsLoaderService.hideLoader();
            }
            return this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        } else {
            this.tabService.notifyChange(<LmsEventDetails>({
                type: tabType,
                data: tab
            }));
        }

        if (tab.tabSearchParameter && !tab.tabSearchParameter.searchText) {
            this.lmsLoaderService.hideLoader();
        }
        return this.tabService.getTabById(Math.abs(route.params['tabid']));
    }
}
